import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage as setLanguageAction } from "../../_store/reducers/languageReducer";
import { Globe, ChevronDown } from "lucide-react";
import { updateUserLanguage } from "../../requests";
import { setAuthToken } from "../../config/Axios";

export const persistLanguage = async (value) => {
  // Only sync to DB when the user is authenticated
  if (!setAuthToken()) return;
  try {
    await updateUserLanguage({ language: value });
  } catch (error) {
    console.error("Failed to update language preference:", error);
  }
};

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    dispatch(setLanguageAction(value));
    localStorage.setItem("language", value); // Save to localStorage
    persistLanguage(value);
    setOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      {/* Trigger button */}
      <div
        onClick={toggleDropdown}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          padding: "6px 10px",
          borderRadius: "8px",
          background: "var(--color-light, #f9fafb)",
          border: "1px solid #e5e7eb",
          fontSize: "14px",
          fontWeight: "500",
          textTransform: "uppercase",
        }}
      >
        <Globe size={18} />
        <span>{lang}</span>
        <ChevronDown size={16} />
      </div>

      {/* Dropdown menu */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.08)",
            zIndex: 1000,
            width: "100%",
          }}
        >
          <div
            onClick={() => handleSelect("en")}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "14px",
              textAlign: "left",
              textTransform: "uppercase",
            }}
          >
            en
          </div>
          <div
            onClick={() => handleSelect("ar")}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "14px",
              textAlign: "left",
              textTransform: "uppercase",
            }}
          >
            ar
          </div>
        </div>
      )}
    </div>
  );
};


export const LanguageSwitcher2 = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);

  const handleClick = () => {
    const nextLang = lang === "en" ? "ar" : "en";
    dispatch(setLanguageAction(nextLang));
    localStorage.setItem("language", nextLang);
    persistLanguage(nextLang);
  };
  return (
    <div
      style={{
        height: "2rem",
      }}
      className={`pe-cursor d-flex align-items-center justify-content-center`}
      onClick={handleClick}
    >
      <img
        style={{
          width: "1.2rem",
          color: "#6B7280",
        }}
        className="img-fluid"
        src={`${process.env.PUBLIC_URL}/img/langIcon.PNG`}
        alt={lang}
        
      />


      {/* <svg
        width="20"
        height="20"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="#6B7280"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M52 19.17a39.79 39.79 0 0 1-20 5.33 39.79 39.79 0 0 1-20-5.33" />
        <path d="M12 44.88a40 40 0 0 1 39.92 0" />
        <path d="M29 56a40 40 0 0 1 0-48" />
        <path d="M35 8a40 40 0 0 1 0 48" />
       
        <circle cx="32" cy="32" r="24" />
      </svg> */}
    </div>
  );
};

export default LanguageSwitcher;
